appSocial.component('favoritesCard', {
    templateUrl: 'widgets/portfolio/components/favorites-card/FavoritesCardComponent.html',
    bindings: {
        trader: '<',
        lastTraderId: '<'
    },
    controller: class FavoritesCardComponent {
        constructor($state,
                    $scope,
                    SocialLocaleService,
                    SocialUtils,
                    SocialActionService,
                    SocialTypes,
                    SocialUserService,
                    SocialFavoriteService) {

            this.translation = SocialLocaleService.translation;

            /**
             * @type {SocialUser}
             */
            this.user = SocialUserService.get()

            /**
             * @type {SocialUtils}
             */
            this.utils = SocialUtils;

            /**
             * @type {SocialActionService}
             */
            this.actionService = SocialActionService;

            /**
             * @type {SocialFavoriteService}
             */
            this.favoriteService = SocialFavoriteService;

            /**
             * @type {SocialTypes}
             */
            this.types = SocialTypes;

            this.action = this.types.CopyAction;
        }

        $onInit() {
        }

        $onChanges(changes) {
        }

        $onDestroy() {
        }

        navigate() {
            this.utils.navigate('root.app.socialLeader', {id: this.trader.id});
        }

        deleteFavorite() {
            this.favoriteService.deleteFavorite(this.trader);
        }

        /**
         * @param {CopyAction} action
         */
        callAction(action) {
            return this.actionService.callAction(action, this.trader);
        }

        copy() {
            const {CopyAction} = this.types;
            this.actionService.stateCheck({trader: this.trader, action: CopyAction.StartCopy})
        }
    }
});
